var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 423,
    viewBox: "0 0 429 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9578 192C53.9578 185.373 59.3304 180 65.9578 180H130.656C137.284 180 142.656 185.373 142.656 192V331.205C142.656 337.833 137.284 343.205 130.656 343.205H65.9578C59.3304 343.205 53.9578 337.833 53.9578 331.205V192ZM96.5331 249.185C82.3269 249.185 70.8105 237.669 70.8105 223.462C70.8105 209.256 82.3269 197.74 96.5331 197.74C110.739 197.74 122.256 209.256 122.256 223.462C122.256 237.669 110.739 249.185 96.5331 249.185ZM96.5331 321.031C82.3269 321.031 70.8105 309.514 70.8105 295.308C70.8105 281.102 82.3269 269.586 96.5331 269.586C110.739 269.586 122.256 281.102 122.256 295.308C122.256 309.514 110.739 321.031 96.5331 321.031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8967 381.5L13.2906 25.653C13.2793 19.0176 18.6552 13.6326 25.2906 13.6326H403.734C410.362 13.6326 415.734 19.0052 415.734 25.6326V381.5",
    stroke: "white",
    strokeWidth: 26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.879 168.744C394.783 160.242 393.494 147.739 385 140.817C376.506 133.895 364.023 135.176 357.119 143.678L325.778 182.271C321.605 187.409 322.381 194.956 327.513 199.138L339.668 209.043C344.812 213.235 352.381 212.457 356.564 207.306L387.879 168.744Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 343.5L329.5 210.5L188 343.5H283.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417 343C423.627 343 429 348.373 429 355V411C429 417.627 423.627 423 417 423H13C6.37259 423 1 417.627 1 411V355C1 348.373 6.37259 343 13 343H417ZM236 365C213.909 365 196 360.971 196 356C196 351.029 213.909 347 236 347C258.091 347 276 351.029 276 356C276 360.971 258.091 365 236 365Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7456 111.588H112.796M415.734 35.5602V99.5881C415.734 106.216 410.362 111.588 403.734 111.588H313.684M409.806 16.2517L313.684 111.588M313.684 111.588H212.847H112.796M313.684 111.588L220.705 16.2517M207.085 16.2517L112.796 111.588M112.796 111.588L15.3647 16.2517",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/stage.58ad2680e1c603e9664c7458e9342e49.svg";
export { ForwardRef as ReactComponent };